module.exports = __webpack_public_path__ + "static/media/4_Dicut_02.0256c596.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/4_Dicut_02.jpg
// module id = 1737
// module chunks = 0